export default __webpack_public_path__ + "static/media/(9).ca736739.jpg";